import React from 'react';
import PropTypes from 'prop-types';
import SmartAutoCustomizationGroups from './SmartAutoCustomizationGroups';

const SmartAutoCustomizationGroupsPicker = ({ sacGroupsCollection }) => {
  if (!sacGroupsCollection) {
    return null;
  }

  return (
    <SmartAutoCustomizationGroups collection={sacGroupsCollection} />
  );
};

SmartAutoCustomizationGroupsPicker.propTypes = {
  sacGroupsCollection: PropTypes.object.isRequired,
};

export default SmartAutoCustomizationGroupsPicker;
